import { AnimatePresence } from 'framer-motion';
import type { AppProps } from 'next/app';
import { ThemeProvider } from 'styled-components';

import GlobalStyles from 'utils/styles/global-styles';
import theme from 'utils/styles/theme';

import NonFunctionals from 'components/NonFunctionals';
import Head from 'u9/components/Head';

const App = ({ Component, pageProps, router }: AppProps) => (
  <>
    <Head />

    <ThemeProvider theme={theme}>
      <NonFunctionals>
        <AnimatePresence exitBeforeEnter={true} initial={false}>
          <Component key={router.route} router={router} {...pageProps} />
        </AnimatePresence>
      </NonFunctionals>

      <GlobalStyles />
    </ThemeProvider>
  </>
);

export default App;
